import React from "react";
import { PageHeader, Marker } from "./../Components";
import GoogleMap from "google-map-react";
import setNavigation from "actions/set_navigation";
import create_reviews from "actions/create_reviews";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link } from "react-router-dom";
import { Col } from "Components";
import {
  NotificationContainer,
  NotificationManager
} from "react-notifications";

// import JSONTree from 'react-json-tree';
class Contact extends React.PureComponent {
  state = {
    contact: ""
  };
  submit = async () => {
    await this.props.create_reviews(this.state);
  };

  validateEmail = email => {
    const regex = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@(([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regex.test(String(email).toLowerCase());
  };
  componentWillReceiveProps(props) {
    if (
      props.alert &&
      props.alert !== this.props.alert &&
      props.alert.message
    ) {
      if (props.alert.type === "success") {
        NotificationManager.success(props.alert.message, "Başarılı");
        this.setState({
          contact: "",
          email: "",
          name: "",
          last_name: "",
          customer_number: "",
          subject: "",
          phone: ""
        });
        // notification.success({
        //   message: props.alert.message,
        //   description: props.alert.description
        // });
      } else {
        NotificationManager.error(props.alert.message, "Başarısız");

        // notification.error({
        //   message: props.alert.message,
        //   description: props.alert.description
        // });
      }
    }
  }
  render = () => (
    <div>
      <NotificationContainer />
      <PageHeader headerClass={"contact-us"} pageName="İletişim" />
      {/* <JSONTree data={this.state}/> */}
      <div className="container mt80 mb80 contact_us_page">
        <p className="title">İletişim Formu</p>
        <p className="inner_content">
          Görüş ve önerileriniz en kısa zamanda değerlendirilecek ve sonucu
          hakkında size mutlaka geri dönülecektir. Hizmet ve ürünler ile ilgili
          görüş/öneri ve şikayetlerinizi iletişim formunu doldurarak ya da
          telefon yolu ile bize iletebilirsiniz
        </p>
        <div className="row mt40">
          <Col l={4} m={12}>
            <input
              value={this.state.name}
              onChange={e => {
                this.setState({
                  name: e.target.value
                });
              }}
              placeholder="Adınız"
            />
          </Col>
          <Col l={4} m={12}>
            <input
              value={this.state.last_name}
              onChange={e => {
                this.setState({
                  last_name: e.target.value
                });
              }}
              placeholder="Soyadiniz"
            />
          </Col>
          <Col l={4} m={12}>
            <input
              value={this.state.customer_number}
              onChange={e => {
                this.setState({
                  customer_number: e.target.value
                });
              }}
              placeholder="Müşteri Numaranız"
            />
          </Col>
        </div>
        <div className="row">
          <Col l={4} m={12}>
            <input
              value={this.state.subject}
              onChange={e => {
                this.setState({
                  subject: e.target.value
                });
              }}
              placeholder="Konu"
            />
          </Col>
          <Col l={4} m={12}>
            <input
              value={this.state.email}
              onChange={e => {
                this.setState({
                  email: e.target.value
                });
              }}
              placeholder="E-Posta Adresiniz"
            />
          </Col>
          <Col l={4} m={12}>
            <input
              value={this.state.phone}
              onChange={e => {
                this.setState({
                  phone: e.target.value
                });
              }}
              placeholder="Telefon Numaranız"
            />
          </Col>
        </div>
        <div className="row">
          <textarea
            onChange={e => {
              this.setState({
                contact: e.target.value
              });
            }}
            placeholder="Görüş ve Öneriniz"
          />
          <p className="textarea_tracking">
            <span>{800 - this.state.contact.length}</span> karakter daha
            yazabilirsiniz.
          </p>
        </div>
        <div className="row">
          <button
            onClick={this.submit}
            disabled={
              !this.state.contact ||
              !this.validateEmail(this.state.email) ||
              !this.state.name
            }
            className="submit-btn center-on-md"
          >
            GÖNDER
          </button>
        </div>
        <p className="title mt80">İletişim Bilgileri</p>
        <div className="row mt50">
          <Col l={4} m={12} className="contact_info_item">
            <div className="graphic location" />
            <div className="content">
              <p className="item_title">Adres :</p>
              <p className="item_details">{this.props.config.address}</p>
            </div>
          </Col>
          <Col l={4} m={12} className="contact_info_item">
            <div className="graphic mail" />
            <div className="content">
              <p className="item_title">E-Posta:</p>
              <p className="item_details">{this.props.config.email}</p>
            </div>
          </Col>
          <Col l={4} m={12} className="contact_info_item">
            <div className="graphic phone" />
            <div className="content">
              <p className="item_title">Telefon:</p>
              <p className="item_details">{this.props.config.phone}</p>
            </div>
          </Col>
        </div>
        <div
          className={`row ${this.props.screen.mq === "l" ? "mt50" : "mt20"}`}
        >
          {this.props.screen.mq === "l" ? (
            <Col l={4} m={12} className="contact_info_item no_border" />
          ) : null}
          <Col l={4} m={12} className="contact_info_item">
            <div className="graphic roadmap" />
            <Link
              onClick={() => this.props.setNavigation(["branches"])}
              to={"/branches"}
            >
              <div className="content">
                <p className="item_title">Şube ve ATM’ler:</p>
                <p className="item_details highlight">Şube ve ATM Listeleme</p>
              </div>
            </Link>
          </Col>
        </div>
      </div>
      {this.props.config.lat ? (
        <GoogleMap
          style={{
            height: 350,
            width: "100%",
            position: "relative",
            borderTop: "5px solid #ec4f2e"
          }}
          bootstrapURLKeys={{ key: "AIzaSyD68TL9T9Aq8BphoxNdP04eJzvBaWMojFs" }}
          center={[
            parseFloat(this.props.config.lat),
            parseFloat(this.props.config.lng)
          ]}
          zoom={15}
        >
          <Marker
            lat={parseFloat(this.props.config.lat)}
            lng={parseFloat(this.props.config.lng)}
          />
        </GoogleMap>
      ) : (
        ""
      )}
    </div>
  );
}
const mapStateToProps = state => ({
  navigation: state.navigation,
  config: state.config ? state.config.data : {},
  alert: state.reviews ? state.reviews.alert : [],
  screen: state.screen
});
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setNavigation,
      create_reviews
    },
    dispatch
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Contact);
